import { Box, Text } from '@zillow/constellation-10';

import PremiumTag from '../../../PremiumTag';

type Props = {
  isPremiumListing: boolean;
  headingText: string;
};

export function ListingModuleHeading({ isPremiumListing, headingText }: Props) {
  return (
    <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', gap: 'tight' }}>
      {isPremiumListing && <PremiumTag />}
      <Text
        className="ConnectedCard-Heading"
        asChild
        css={{
          marginRight: { base: '200', lg: '400' },
          textStyle: { base: 'body-bold', lg: 'heading-xs' },
        }}
      >
        <h2>{headingText}</h2>
      </Text>
    </Box>
  );
}
